// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RxmFM{position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#fff;border-radius:50%;display:none;height:32px;height:3.2rem;justify-content:center;overflow:hidden;width:32px;width:3.2rem}@media (min-width:600px){.RxmFM{display:-ms-inline-flexbox;display:inline-flex;margin-right:4px}}html[dir=ltr] .RxmFM{margin-right:1.6rem}html[dir=rtl] .RxmFM{margin-left:1.6rem}._3U1-1{max-height:100%;width:auto}._2re1J{color:#fff;display:block;font-size:15px;font-size:1.5rem;font-weight:700}._2MqH5{-ms-flex:1 1;flex:1 1}._22fKI td:first-child{width:100%}._22fKI .table__cell{padding:4px 2px}@media (min-width:600px){._22fKI .table__cell{padding:16px}}._3FQVq{color:#95a1bd;padding:4px;white-space:nowrap}._1Yo2W{max-width:124px;text-align:center}._2PU1a{min-width:80px}@media (min-width:600px){._2PU1a{min-width:150px}}._1VCKu{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-bottom:3.2rem}", ""]);
// Exports
exports.locals = {
	"avatar": "RxmFM",
	"avatar__img": "_3U1-1",
	"avatar__initials": "_2re1J",
	"avatar__name": "_2MqH5",
	"table": "_22fKI",
	"table__notesCellEmpty": "_3FQVq",
	"table__showNotes": "_1Yo2W",
	"table__clinicCell": "_2PU1a",
	"backButton": "_1VCKu"
};
module.exports = exports;
